import { createContext } from "react";

const UserLanguageContext = createContext({
  language: "eu",
  setLanguage: () => {},
});

export default UserLanguageContext;